export { default } from './message-banner';



// WEBPACK FOOTER //
// ./app/components/landing/message-banner/index.js